import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Clock, X, CreditCard } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function TrialBanner() {
  const navigate = useNavigate();
  const [trialStatus, setTrialStatus] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkTrialStatus();
  }, []);

  const checkTrialStatus = async () => {
    try {
      const response = await axios.get(`${API}/user/trial-status`, { withCredentials: true });
      setTrialStatus(response.data);
    } catch (error) {
      // Silently fail if user not authenticated (401) - don't show console errors
      if (error.response?.status !== 401) {
        console.error('Failed to fetch trial status:', error);
      }
      setTrialStatus(null);
    } finally {
      setLoading(false);
    }
  };

  const handlePayNow = () => {
    navigate('/pricing');
  };

  if (loading || !trialStatus || !trialStatus.trial_active || dismissed) {
    return null;
  }

  const daysRemaining = trialStatus.days_remaining;
  const hoursRemaining = trialStatus.hours_remaining;

  return (
    <div className="bg-gradient-to-r from-yellow-400 via-orange-400 to-red-400 text-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3 flex-1">
            <Clock className="w-5 h-5 flex-shrink-0 animate-pulse" />
            <div className="flex-1">
              <div className="font-bold text-sm sm:text-base">
                {daysRemaining > 0 ? (
                  <>Your 3-Day Free Trial: {daysRemaining} day{daysRemaining !== 1 ? 's' : ''} remaining</>
                ) : (
                  <>Your Trial Ends in {hoursRemaining} hours!</>
                )}
              </div>
              <div className="text-xs sm:text-sm opacity-90">
                Complete payment to continue enjoying premium features
              </div>
            </div>
          </div>
          
          <div className="flex items-center gap-2">
            <button
              onClick={handlePayNow}
              className="bg-white text-orange-600 px-4 py-2 rounded-lg font-semibold text-sm hover:bg-gray-100 transition-all flex items-center gap-2 whitespace-nowrap"
            >
              <CreditCard className="w-4 h-4" />
              Pay Now
            </button>
            
            <button
              onClick={() => setDismissed(true)}
              className="p-2 hover:bg-white/20 rounded-lg transition-all"
              aria-label="Dismiss banner"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TrialBanner;
